<svg width="25" height="82" viewBox="0 0 25 82" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.671875" y="0.5" width="24" height="81" rx="12" fill="#333333"/>
<rect x="7.67188" y="67" width="10" height="10" rx="5" fill="#666666"/>
</svg>
